/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React, { useState } from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { filterCollectionStories, getCollectionStories, getAuthorStories, tagPageStories } from "../../utils";
import { useSelector } from "react-redux";

const WithSubsequentLoad = Component => {
  const WrappedComponent = ({ collection, config = {} }) => {
    const mountAtPrefix = useSelector(state => get(state, ["qt", "config", "mountAt"], ""));
    const pageType = useSelector(state => get(state, ["qt", "pageType"], ""));
    const initialLoadCount = parseInt(get(config, ["initialLoadCount"], 3));
    const collectionStories = filterCollectionStories(collection.items);
    const initialCollectionItems = collectionStories.slice(0, initialLoadCount);
    const [collectionItems, setCollectionItems] = useState(initialCollectionItems);
    const [isLoading, setIsLoading] = useState(false);
    const intialLoadMoreButtonState = initialCollectionItems.length >= initialLoadCount;
    const [isLoadMoreVisible, setIsLoadMoreVisible] = useState(intialLoadMoreButtonState);
    const updatedCollection = { ...collection, items: collectionItems };
    const tagSlugs = useSelector(state => get(state, ["qt", "data", "tagSlug"], ""));
    const [sectionPageOffset, setSectionPageOffset] = useState(collection.currentOffset);

    const getMoreStories = async (offset, limit) => {
      setIsLoading(true);
      let response;
      switch (pageType) {
        case "author-page":
          const authorId = get(collectionItems, ["0", "story", "author-id"], "");
          response = await getAuthorStories(authorId, offset, limit, mountAtPrefix);
          break;
        case "tag-page":
          const tagStoriesData = await tagPageStories(offset, limit, mountAtPrefix, tagSlugs);
          const tagItems = tagStoriesData.stories.map(item => {
            return { story: item, type: "story" };
          });
          response = { items: tagItems };
          break;
        default:
          offset = sectionPageOffset || offset;
          response = await getCollectionStories(collection.slug, offset, limit, mountAtPrefix);
          setSectionPageOffset(sectionPageOffset + limit);
      }
      if (response.items.length) {
        setCollectionItems([...collectionItems, ...response.items]);
      } else {
        setIsLoadMoreVisible(false);
      }
      setIsLoading(false);
    };
    return (
      <Component
        collection={updatedCollection}
        config={config}
        getMoreStories={getMoreStories}
        isLoadMoreVisible={isLoadMoreVisible}
        isLoading={isLoading}
      />
    );
  };

  WrappedComponent.propTypes = {
    collection: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired
  };

  return WrappedComponent;
};

export default WithSubsequentLoad;
